import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import WeeklyTime from './WeeklyTime/WeeklyTime';
import WeekPicker from './WeekPicker/index';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import routes from '../../../Utils/routes.json';
import { useHistory } from 'react-router-dom';
import BreadCrumb from '../../../Components/BreadCrumb';
import KenCard from '../../../global_components/KenCard';
import ControlledTreeView from '../../../Components/KenCheckBoxTree';
import Calendar from './Calendar';
import { useEffect, useState } from 'react';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import resourcesData from './data/resources.json';
import resourcesDataSecond from './data/resourcesSecond.json';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

// Initially Fetch events(eventsData) from API, on DnD use `allEventData` object to send updated event list to backend server
import { eventsData } from './data/events';
import { eventsDataSecond } from './data/eventSecond';

import treeItemData from './data/treeItem.json';
import timeData from './data/time.json';

import treeItemDataSecond from './data/treeItem2.json';
import { RiFilterLine } from 'react-icons/ri';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import KenSelectWrap from '../../../global_components/KenSelect';
import { Today } from '@material-ui/icons';

const TODAY = moment().format('YYYY-MM-DD');

const useToggleStyles = makeStyles((theme) => ({
  root: {
    '&&': {
      display: 'inline-flex',
      color: theme.palette.KenColors.primary,
      backgroundColor: theme.palette.KenColors.kenWhite,
      boxShadow:
        '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  },
  selected: {
    '&&': {
      backgroundColor: theme.palette.KenColors.primary,
      color: theme.palette.KenColors.kenWhite,
      '&:hover': {
        backgroundColor: theme.palette.KenColors.primary,
        color: theme.palette.KenColors.kenWhite,
        boxShadow: 'none',
      },
    },
  },
}));

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  headerRight: {
    display: 'flex',
    justifyContent: 'end',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  calenderSidebar: {
    margin: '0',
    padding: '0',
  },
  pageActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    margin: '10px 0',
  },
  actionBtn: {
    margin: '0 10px',
  },
  kenDateTimePickerColor: {
    top: '-1px',
  },
}));

const arrayBreadCrumb = [
  { head: 'HOME', url: routes.home},
  {
    head: 'SESSION SCHEDULER',
  },
];

const selectOptions = [
  {
    label: 'Today',
    value: 'today',
  },
];

const SessionScheduler = () => {
  const history = useHistory();
  const classes = useStyles();
  const toggleClasses = useToggleStyles();

  const [treeItems, setTreeItems] = useState([]);
  //events and setEvents is for rendering and filter event-data using checkbox
  const [events, setEvents] = useState([]);
  const [resources, setResources] = useState([]);

  const [expanded, setExpanded] = useState(['2']);
  const [dateToViewTT, setDateToViewTT] = useState(new Date());

  const [selected, setSelected] = useState(['202']);
  const [toogleButton, setToogleButton] = useState(true);
  const [calendarDay, setCalendarDay] = useState(TODAY);
  const [weekDay, setWeekDay] = useState(TODAY);
  const [calendarMode, setCalendarMode] = useState('facility'); // {'facility', 'faculty'}
  const [calendarView, setCalendarView] = useState('today'); // 'week' -> Weekly, 'month' -> Monthly
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [fromDate, setfromDate] = useState(new Date());
  const [toDate, settoDate] = useState(new Date());
  const [currentWeek, setCurrentWeek] = useState([]);

  /**
   * allEventData is for update event-list after drag and drop
   * The reason to use another object(allEventData) instead of "events" is that React is not allow us to update state of events after DnD*/
  const [allEventData, setAllEventData] = useState(eventsData);
  const handleDateChange = (date) => {
    setDateToViewTT(new Date(date));
  };
  const changeWeek = (op) => {
    let newWeekStart;
    if (op === 'next') {
      let endOfWeek = moment(dateToViewTT).endOf('week').toDate();
      newWeekStart = moment(endOfWeek).add(2, 'days');
    } else {
      let startOfWeek = moment(dateToViewTT).startOf('week').toDate();
      newWeekStart = moment(startOfWeek).subtract(2, 'days');
    }

    setDateToViewTT(new Date(newWeekStart));
  };

  useEffect(() => {
    console.log('toogleButton', toogleButton);
    if (toogleButton === true) {
      console.log('resourcesDataSecond', resourcesData);

      setTreeItems(treeItemData);
      setResources(resourcesData);
      // setAllEventData(eventsData);
    } else {
      console.log('resourcesDataSecond', resourcesDataSecond);
      setTreeItems(treeItemDataSecond);
      setResources(resourcesDataSecond);
      setAllEventData(eventsDataSecond);
    }
  }, [toogleButton]);

  useEffect(() => {
    if (toogleButton === true) {
      console.table('data--->', allEventData, eventsData);
      const todayEvents = eventsData.filter(
        (event) =>
          moment(calendarDay).startOf('day') <= moment(event.start) &&
          moment(event.end) < moment(calendarDay).endOf('day')
      );

      let selectedEvents = [];
      for (const key of selected) {
        let temp = todayEvents.filter((event) => event.treeItemId === key);
        selectedEvents.push(...temp);
      }
      console.log('selectedEvents', selectedEvents);
      setEvents(selectedEvents);
    } else {
      const todayEvents = eventsDataSecond.filter(
        (event) =>
          moment(calendarDay).startOf('day') <= moment(event.start) &&
          moment(event.end) < moment(calendarDay).endOf('day')
      );

      let selectedEvents = [];
      for (const key of selected) {
        let temp = todayEvents.filter((event) => event.treeItemId === key);
        selectedEvents.push(...temp);
      }

      setEvents(selectedEvents);
    }
  }, [calendarDay, selected, toogleButton, allEventData]);

  const handleToggle = (event, nodeIds) => {
    if (event.target.nodeName !== 'svg') {
      return;
    }

    setExpanded(nodeIds);
  };
  const handleSelect = (event, nodeIds) => {
    if (event.target.nodeName === 'svg') {
      return;
    }
    const first = nodeIds[0];
    if (selected.includes(first)) {
      setSelected(selected.filter((id) => id !== first));
    } else {
      setSelected([first, ...selected]);
    }
  };
  console.log('selected', selected);

  const handleCalendarMode = (event, nextView) => {
    setCalendarMode(nextView);
  };

  const handlePrevDay = () => {
    const nextCalendarDay = moment(calendarDay)
      .subtract(1, 'day')
      .format('YYYY-MM-DD');
    setCalendarDay(nextCalendarDay);
  };

  const handleCurrentDay = (e) => {
    setCalendarDay(e.target.value);
  };
  function getCurrentWeek(selectedDate) {
    let weekStart = moment(selectedDate).clone().startOf('isoWeek');
    let days = [];

    for (var i = 0; i <= 6; i++) {
      days.push({
        date: moment(weekStart).add(i, 'days').format('DD/MM/YYYY'),
        day: moment(weekStart).add(i, 'days').format('dddd'),
      });
    }
    return days;
  }

  useEffect(() => {
    let weekDates = [];
    if (dateToViewTT) {
      weekDates = getCurrentWeek(dateToViewTT);
    }

    setCurrentWeek(weekDates);
  }, [dateToViewTT]);
  console.log('currentWeek', currentWeek);

  const handleNextDay = () => {
    const nextCalendarDay = moment(calendarDay)
      .add(1, 'day')
      .format('YYYY-MM-DD');
    setCalendarDay(nextCalendarDay);
  };

  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
  };

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>

      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Grid container>
            <Grid item xs={6} className={classes.headerLeft}>
              <Typography variant="h6" className={classes.title}>
                Session Scheduler
              </Typography>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      <Box className={classes.pageActions}>
        <ToggleButtonGroup
          size="small"
          value={calendarMode}
          exclusive
          onChange={handleCalendarMode}
        >
          <ToggleButton
            classes={toggleClasses}
            value="facility"
            aria-label="facility"
            onClick={() => {
              setToogleButton(true);
              toast.success('Change to Facility');
            }}
          >
            Facility
          </ToggleButton>
          <ToggleButton
            classes={toggleClasses}
            value="faculty"
            aria-label="faculty"
            onClick={() => {
              setToogleButton(false);
              toast.success('Change to Faculty Member');
            }}
          >
            Faculty Member
          </ToggleButton>
        </ToggleButtonGroup>
        <Button
          startIcon={<AddIcon />}
          className={classes.actionBtn}
          variant="contained"
          color="primary"
        >
          Add
        </Button>
        <Button
          startIcon={<RiFilterLine />}
          className={classes.actionBtn}
          variant="contained"
          color="primary"
        >
          Filter
        </Button>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <KenSelectWrap
            options={selectOptions}
            value={selectValue}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChange}
            required
          />
        </Grid>
        <Grid item xs={12} md={4} style={{ display: 'flex' }}>
          <ButtonGroup style={{ background: '#ffffff' }}>
            <Button onClick={handlePrevDay}>
              <ChevronLeftIcon />
            </Button>
            <KenDateTimePicker
              inputBaseRootClass={classes.kenDateTimePickerColor}
              value={calendarDay}
              type="date"
              required={true}
              defaultValue={calendarDay}
              onChange={handleCurrentDay}
            />
            {/* <Button onClick={handleCurrentDay}>
        {moment(calendarDay).format('MMM DD, YYYY')}
      </Button> */}
            <Button onClick={handleNextDay}>
              <ChevronRightIcon />
            </Button>
          </ButtonGroup>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <ToggleButtonGroup size="small" value={calendarView} exclusive>
            <ToggleButton
              classes={toggleClasses}
              value="week"
              aria-label="week"
              onClick={() => {
                setCalendarView('week');
              }}
            >
              Weekly
            </ToggleButton>
            <ToggleButton
              classes={toggleClasses}
              value="month"
              aria-label="month"
              onClick={() => {
                setCalendarView('month');
              }}
            >
              Monthly
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>
      <KenCard className={classes.calenderSidebar} elevation={0}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3} style={{ padding: '0' }}>
            <Typography>SESSIONS</Typography>

            <ControlledTreeView
              treeItems={treeItems}
              expanded={expanded}
              selected={selected}
              onNodeToggle={handleToggle}
              onNodeSelect={handleSelect}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            {toogleButton === true && (
              <Calendar
                calendarDay={calendarDay}
                toogleButton={toogleButton}
                calendarResources={resourcesData}
                calendarEvents={events}
                setAllEventData={setAllEventData}
                // allEventData={allEventData}
              />
            )}
            {toogleButton === false && (
              <Calendar
                calendarDay={calendarDay}
                toogleButton={toogleButton}
                calendarResources={resourcesDataSecond}
                calendarEvents={events}
                setAllEventData={setAllEventData}
                // allEventData={allEventData}
              />
            )}
          </Grid>
        </Grid>
        <ToastContainer />
      </KenCard>
    </Box>
  );
};

export default SessionScheduler;
